import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { FieldProps } from '../../../../../components/Form/fields';
import { LANGUAGE_LEVELS } from '../../../../../constants/languages';

export const LanguageLevelField = ({
  value,
  onChange,
  readonly,
  errors,
}: FieldProps<string>) => {
  const [t] = useTranslation();
  const options = LANGUAGE_LEVELS;

  const fieldErrors = errors.filter((err) => err.path?.match(/^[a-zA-Z]*$/));

  return (
    <>
      <Select
        style={{ width: '100%' }}
        disabled={readonly}
        value={value}
        onChange={onChange}
      >
        {options.map((option) => (
          <Select.Option value={option} key={option}>
            <span>{t(`resume.languageLevels.${option}`)}</span>
          </Select.Option>
        ))}
      </Select>
      {!readonly && fieldErrors.length > 0 && (
        <div className="form--error">
          {fieldErrors.map((err) => err.message).join('. ')}
        </div>
      )}
    </>
  );
};

export default LanguageLevelField;
